export default __webpack_public_path__ + "static/media/devraj-chatribin.6109e5cf.webp";